// Shared bits for the Operations > Partners hub.

// Public-facing referral URL for a partner slug (same origin the app runs on).
// NOTE: origin comes from the browser's address bar — in local dev it shows
// localhost even when APP_BASE_URL_OVERRIDE points QR codes at the LAN IP.
export const partnerUrlFor = (slug) =>
  `${window.location.protocol}//${window.location.host}/partner/${slug}`;

// Events land on their capture page, not the partner referral page.
export const eventUrlFor = (slug) =>
  `${window.location.protocol}//${window.location.host}/event/${slug}`;

// Public QR endpoint (no auth — it's printed on flyers). The optional variant
// busts the 24h browser cache when the branded-logo flag flips.
export const qrSrcFor = (slug, variant) =>
  `${process.env.REACT_APP_API_URL}/public/partners/${slug}/qr.png${
    variant ? `?v=${variant}` : ''
  }`;

// Paperwork *status* is visible with partners:view, but the clickable signed-PDF
// links carry SSNs (W-9s) — the signed-pdf route rejects partners:view, so only
// render links for users the route will actually let through.
export const canViewSignedPaperwork = (hasPermission) =>
  hasPermission('partners:manage') ||
  hasPermission('referral_payouts:view') ||
  hasPermission('referral_payouts:manage') ||
  hasPermission('documents:manage');
